/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({

    // Page Header
    // Added
    Titlespt: {
        id: 'qnb.spt.IpidPage.Titlespt',
        defaultMessage: 'Saga Travel Insurance'
    },
    SubTitleIPID: {
        id: 'qnb.spt.IpidPage.SubTitleIPID',
        defaultMessage: 'Insurance Product Information Document'
    },
    SubTitleCompany: {
        id: 'qnb.spt.IpidPage.SubTitleCompany',
        defaultMessage: 'Company: Saga Services Limited'
    },
    SubTitleProduct: {
        id: 'qnb.spt.IpidPage.SubTitleProduct',
        defaultMessage: 'Product: {product}'
    },

    // Product types
    ProductSingleTripTravelInsurance: {
        id: 'qnb.spt.IpidPage.SingleTripTravelInsurance',
        defaultMessage: 'Single Trip Travel Insurance'
    },
    ProductAnnualTripTravelInsurance: {
        id: 'qnb.spt.IpidPage.AnnualTripTravelInsurance',
        defaultMessage: 'Annual Travel Insurance'
    },

    // Legal Disclaim
    LegalDisclaim: {
        id: 'qnb.spt.IpidPage.LegalClaim',
        defaultMessage: 'Saga Services Limited is an insurance intermediary, authorised and regulated by the Financial Conduct Authority under FRN 311557. Saga Services Limited has arranged for its travel insurance to be underwritten by Astrenska Insurance Limited which is authorised and regulated by the Financial Conduct Authority under FRN 202846.'
    },

    //    SubHeader
    SubHeaderP1: {
        id: 'qnb.spt.IpidPage.SubHeaderP1',
        defaultMessage: 'The full terms and conditions of your cover including complete pre-contractual and contractual information can be found in your policy wording and Schedule, please ensure you read all these documents.'
    },
    SubHeaderP2: {
        id: 'qnb.spt.IpidPage.SubHeaderP2',
        defaultMessage: 'What is this type of insurance?'
    },
    WhatIsTheTypeOfInsurance: {
        id: 'qnb.spt.IpidPage.SubHeaderP3',
        defaultMessage: 'Your Saga Travel Insurance policy is designed to protect you against unforeseen events relating to or occurring whilst travelling away from home. {benefitLimits}'
    },
    benefitLimitsPerTripNotPerPerson: {
        id: 'qnb.spt.IpidPage.benefitLimitsPerTripNotPerPerson',
        defaultMessage: 'All benefit limits are per trip and not per person.'
    },
    benefitLimitsPerPerson: {
        id: 'qnb.spt.IpidPage.benefitLimitsPerPerson',
        defaultMessage: 'All benefit limits are per person.'
    },
    benefitLimitsPerPersonPerTrip: {
        id: 'qnb.spt.IpidPage.benefitLimitsPerPersonPerTrip',
        defaultMessage: 'All benefit limits are per person, per trip.'
    },
    baggageAmountEssential: {
        id: 'qnb.spt.IpidPage.baggageAmountEssential',
        defaultMessage: '1,750 (£400 single article limit)'
    },
    baggageAmountStandard: {
        id: 'qnb.spt.IpidPage.baggageAmountStandard',
        defaultMessage: '3,000 (£600 single article limit)'
    },
    baggageAmountPlus: {
        id: 'qnb.spt.IpidPage.baggageAmountPlus',
        defaultMessage: '7,500 (£1,000 single article limit)'
    },
    baggageAmountStandardAnnual: {
        id: 'qnb.spt.IpidPage.baggageAmountStandardAnnual',
        defaultMessage: '5,000 (£750 single article limit)'
    },
    baggageAmountPlusAnnual: {
        id: 'qnb.spt.IpidPage.baggageAmountPlusAnnual',
        defaultMessage: '10,000 (£1,250 single article limit)'
    },
    baggageAmountSelect: {
        id: 'qnb.spt.IpidPage.baggageAmountSelect',
        defaultMessage: '1,750'
    },

    //  Where am I covered?
    WhereAmICovered: {
        id: 'qnb.spt.IpidPage.WhereAmICovered',
        defaultMessage: 'United Kingdom'
    },
    PlusOtherCountries: {
        id: 'qnb.spt.IpidPage.PlusOtherCountries',
        defaultMessage: ' (plus any other destinations shown in your policy schedule)'
    },

    // Insured
    Cancellation: {
        id: 'qnb.spt.IpidPage.Cancellation',
        defaultMessage: 'Cancellation up to £{cancellationAmount}'
    },
    MissedDeparture: {
        id: 'qnb.spt.IpidPage.MissedDeparture',
        defaultMessage: 'Missed departure up to £{missedDepartureAmount}'
    },
    Abandonment: {
        id: 'qnb.spt.IpidPage.Abandonment',
        defaultMessage: 'Abandonment up to £{abandonmentAmount}'
    },
    LostStolenDamagedBaggage: {
        id: 'qnb.spt.IpidPage.LostStolenDamagedBaggage',
        defaultMessage: 'Lost, stolen or damaged baggage up to £{lostStolenDamagedBaggage}'
    },
    MedicalExpensesDirect: {
        id: 'qnb.spt.IpidPage.MedicalExpensesDirect',
        defaultMessage: 'Emergency medical expenses and repatriation up to £{medicalAmount} and £2,000,000 for UK trips'
    },
    DentalEmergency: {
        id: 'qnb.spt.IpidPage.DentalEmergency',
        defaultMessage: 'Dental emergencies up to £{dentalEmergencyAmount}*'
    },
    MedicalExpensesDirectEssential: {
        id: 'qnb.spt.IpidPage.MedicalExpensesDirectEssential',
        defaultMessage: 'Emergency medical expenses and repatriation up to £{medicalAmount}'
    },
    MedicalExpensesAggs: {
        id: 'qnb.spt.IpidPage.MedicalExpensesAggs',
        defaultMessage: 'Emergency medical expenses and repatriation up to £8,000,000 and £2,000,000 for UK trips'
    },
    DelayedBaggage: {
        id: 'qnb.spt.IpidPage.DelayedBaggage',
        defaultMessage: 'Delayed baggage up to £{delayedBaggageAmount}*'
    },
    LossOfPassport: {
        id: 'qnb.spt.IpidPage.LossOfPassport',
        defaultMessage: 'Loss of passport up to £{passportAmount}*'
    },
    DelayedDeparture: {
        id: 'qnb.spt.IpidPage.DelayedDeparture',
        defaultMessage: 'Delayed departure up to £{delayedDepartureAmount}'
    },
    PersonalMoney: {
        id: 'qnb.spt.IpidPage.PersonalMoney',
        defaultMessage: 'Personal money up to £{personalMoney}'
    },
    PersonalLiability: {
        id: 'qnb.spt.IpidPage.PersonalLiability',
        defaultMessage: 'Personal liability up to £{personalLiability}'
    },
    HijackAndMugging: {
        id: 'qnb.spt.IpidPage.HijackAndMugging',
        defaultMessage: 'Hijack/Mugging up to £1,000*'
    },
    HospitalBenefit: {
        id: 'qnb.spt.IpidPage.HospitalBenefit',
        defaultMessage: 'Hospital benefit up to £{hospitalBenefitAmount}*'
    },
    CriminalInjury: {
        id: 'qnb.spt.IpidPage.CriminalInjury',
        defaultMessage: 'Criminal injury benefit up to £{criminalInjuryAmount}*'
    },
    PetCare: {
        id: 'qnb.spt.IpidPage.PetCare',
        defaultMessage: 'Pet care up to £{petCareAmount}*'
    },
    AirRage: {
        id: 'qnb.spt.IpidPage.AirRage',
        defaultMessage: 'Air rage up to £1,000*'
    },
    DelayedFlightAssistance: {
        id: 'qnb.spt.IpidPage.DelayedFlightAssistance',
        defaultMessage: 'Delayed flight assistance - {delayedFlightAssistanceTime} hour delay'
    },
    LegalExpenses: {
        id: 'qnb.spt.IpidPage.LegalExpenses',
        defaultMessage: 'Legal expenses up to £50,000*'
    },
    CruiseMissedPort: {
        id: 'qnb.spt.IpidPage.CruiseMissedPort',
        defaultMessage: 'Cruise - Missed port - £100 per missed port (up to £300 total)'
    },
    CruiseInterruption: {
        id: 'qnb.spt.IpidPage.CruiseInterruption',
        defaultMessage: 'Cruise - Interruption up to £1,000'
    },
    PersonalAccident: {
        id: 'qnb.spt.IpidPage.PersonalAccident',
        defaultMessage: 'Personal accident up to £{personalAccident} (Death benefit – £{deathBenefit} if aged over 70, £1,000 if aged under 16)'
    },
    SubstituteAccommodation: {
        id: 'qnb.spt.IpidPage.SubstituteAccommodation',
        defaultMessage: 'Substitute accommodation up to £{substituteAccommodation}'
    },
    EnforcedStay: {
        id: 'qnb.spt.IpidPage.EnforcedStay',
        defaultMessage: 'Enforced stay up to £{enforcedStay}'
    },
    WinterSportsTitle: {
        id: 'qnb.spm.IpidPage.WinterSportsTitle',
        defaultMessage: 'Winter Sports Cover'
    },
    WinterSportsMedicalExpenses: {
        id: 'qnb.spt.IpidPage.WinterSportsMedicalExpenses',
        defaultMessage: 'Medical expenses required up to £{winterSportsMedicalExpenses} if you have an accident when taking part in a winter sports activity listed in the Policy Booklet'
    },
    WsMedicalSingleEssential: {
        id: 'qnb.spt.IpidPage.WsMedicalSingleEssential',
        defaultMessage: '2,000,000'
    },
    WsMedicalSingleStandard: {
        id: 'qnb.spt.IpidPage.WsMedicalSingleStandard',
        defaultMessage: '5,000,000'
    },
    WsMedicalSinglePlus: {
        id: 'qnb.spt.IpidPage.WsMedicalSinglePlus',
        defaultMessage: '15,000,000'
    },
    WsMedicalAnnualStandard: {
        id: 'qnb.spt.IpidPage.WsMedicalAnnualStandard',
        defaultMessage: '10,000,000'
    },
    WsMedicalAnnualPlus: {
        id: 'qnb.spt.IpidPage.WsMedicalAnnualPlus',
        defaultMessage: '20,000,000'
    },
    WinterSportsCoverEquipment: {
        id: 'qnb.spt.IpidPage.WinterSportsCoverEquipment',
        defaultMessage: 'Winter sports equipment up to £750 for your equipment, £550 for hired equipment'
    },
    WinterSportsCoverAvalanche: {
        id: 'qnb.spt.IpidPage.WinterSportsCoverAvalanche',
        defaultMessage: 'Delay due to avalanche up to £300'
    },
    WinterSportsCoverPiste: {
        id: 'qnb.spt.IpidPage.WinterSportsCoverPiste',
        defaultMessage: 'Piste closure – £40 for each day (£400 maximum)'
    },
    WinterSportsCoverSki: {
        id: 'qnb.spt.IpidPage.WinterSportsCoverSki',
        defaultMessage: 'Ski pack up to £350'
    },
    WinterSportsCoverActivities: {
        id: 'qnb.spt.IpidPage.WinterSportsCoverActivities',
        defaultMessage: 'Inability to take part in winter sports activities – £20 for each day (£200 maximum)'
    },

    //    What are my Obligations?
    MyObligations1: {
        id: 'qnb.spt.IpidPage.MyObligations1',
        defaultMessage: 'At the start of your policy you must ensure that you have taken care to answer all the questions honestly, fully and to the best of your knowledge'
    },
    MyObligations2: {
        id: 'qnb.spt.IpidPage.MyObligations2',
        defaultMessage: 'You must contact the emergency assistance service if you or anyone insured under the policy requires inpatient medical treatment, repatriation or your claim is likely to exceed £500'
    },
    MyObligations3: {
        id: 'qnb.spt.IpidPage.MyObligations3',
        defaultMessage: 'You must update us on any changes to pre-existing medical conditions, or if you are diagnosed with a new medical condition'
    },
    MyObligations4: {
        id: 'qnb.spt.IpidPage.MyObligations4',
        defaultMessage: 'You may be asked to provide proof of claims, e.g. bills or medical certificates'
    },
    MyObligations5: {
        id: 'qnb.spt.IpidPage.MyObligations5',
        defaultMessage: 'If you make a medical claim you may be asked to supply your UK doctor\'s name to enable us to access your medical records'
    },

    //    Not insured
    notInsured1: {
        id: 'qnb.spt.IpidPage.notInsured1',
        defaultMessage: 'Claims relating to a pre-existing medical condition that you have not told us about, or of someone who has not been named on the policy'
    },
    notInsured2Single: {
        id: 'qnb.spt.IpidPage.notInsured2Single',
        defaultMessage: 'Trips where you have already left the UK at the time of purchasing this policy'
    },
    notInsured2Annual: {
        id: 'qnb.spt.IpidPage.notInsured2Annual',
        defaultMessage: 'Trips where you have already left the UK at the time of purchasing this policy, except where you renew an existing policy which is due for renewal during the trip'
    },
    notInsured3: {
        id: 'qnb.spt.IpidPage.notInsured3',
        defaultMessage: 'We do not cover any payment which you would normally have made during your travels and/or which does not fall within the events insured under the terms of this policy'
    },
    notInsured4: {
        id: 'qnb.spt.IpidPage.notInsured4',
        defaultMessage: 'Any trips when travelling against the advice of the Foreign, Commonwealth and Development Office'
    },
    notInsuredEssentialTravelOnly: {
        id: 'qnb.spt.IpidPage.notInsuredEssentialTravelOnly',
        defaultMessage: 'Any claims relating to the reason for the Foreign, Commonwealth and Development Office advising against all but essential travel'
    },
    notInsured5: {
        id: 'qnb.spt.IpidPage.notInsured5',
        defaultMessage: 'Activities that are not covered, as shown in the Policy Book'
    },
    notInsured6: {
        id: 'qnb.spt.IpidPage.notInsured6',
        defaultMessage: 'Apart from Coronavirus (COVID-19) cover under \'Cancellation\' and \'Abandonment\' and the \'Emergency medical and associated expenses\' sections, this policy does not cover any claim arising directly or indirectly, from any coronavirus disease (including but not limited to COVID-19) or any related or mutated form of the virus.'
    },
    notInsuredCancellationCover: {
        id: 'qnb.spt.IpidPage.notInsuredCancellationCover',
        defaultMessage: 'Cancellation cover is not included'
    },
    noMissedDepartureCoverWithCancellation: {
        id: 'qnb.spt.IpidPage.noMissedDepartureCoverWithCancellation',
        defaultMessage: 'Cover for Missed departure and Delayed baggage are not included'
    },
    noMissedDepartureCoverWithoutCancellation: {
        id: 'qnb.spt.IpidPage.noMissedDepartureCoverWithoutCancellation',
        defaultMessage: 'Cover for Cancellation, Missed departure and Delayed baggage are not included'
    },
    notInsuredExcess: {
        id: 'qnb.spt.IpidPage.notInsuredExcess',
        defaultMessage: 'Excesses apply to certain sections of your policy as shown in your policy Schedule'
    },

    //    Are there any restrictions on cover?
    Restrictions1: {
        id: 'qnb.spt.IpidPage.Restrictions1',
        defaultMessage: 'Any claim arising from being under the influence or effect of alcohol'
    },
    Restrictions2: {
        id: 'qnb.spt.IpidPage.Restrictions2',
        defaultMessage: 'No cover if you travel against the advice of a medical practitioner or for the purpose of obtaining medical treatment'
    },
    Restrictions3: {
        id: 'qnb.spt.IpidPage.Restrictions3',
        defaultMessage: 'You will be unable to claim for costs incurred for medical treatment that you knew would be required before travelling'
    },
    Restrictions4: {
        id: 'qnb.spt.IpidPage.Restrictions4',
        defaultMessage: 'Claims cannot be made outside of the trip limits specified in your policy Schedule'
    },
    Restrictions5: {
        id: 'qnb.spt.IpidPage.Restrictions5',
        defaultMessage: 'Any claim arising under Emergency Medical and Associated expenses where your pregnancy or childbirth has exceeded 28 weeks (24 weeks for a multiple pregnancy)'
    },
    Restrictions6: {
        id: 'qnb.spt.IpidPage.Restrictions6',
        defaultMessage: 'Any claim as a result of you motorcycling as a rider or passenger on a machine over 125cc: or as a rider or passenger on a machine 125cc or under unless you wear a crash helmet and, as a rider, you hold a full UK motorcycle licence or a valid CBT certificate (DL196)'
    },

    //    When and how do I pay?
    WhenAndHowDoIPay: {
        id: 'qnb.spt.IpidPage.WhenAndHowDoIPay',
        defaultMessage: 'Payment will be required when you take out the policy. You can pay by credit/debit card.'
    },

    //    When does the cover start and end?
    StartAndEndOfCover: {
        id: 'qnb.spt.IpidPage.StartAndEndOfCover',
        defaultMessage: 'Your cover will start on {startCoverDate} and end on {endCoverDay}.'
    },

    // technical purpoes delete when not needed

    Specyfic: {
        id: 'qnb.spt.IpidPage.Specyfic',
        defaultMessage: 'Specyfic data to product'
    },
    Common: {
        id: 'qnb.spt.IpidPage.Common',
        defaultMessage: 'Common data'
    },
    PlaceHolder: {
        id: 'qnb.spt.IpidPage.PlaceHolder',
        defaultMessage: ''
    },

    worldwideExcluding: {
        id: 'qnb.spt.IpidPage.worldwideExcluding',
        defaultMessage: 'Worldwide excluding the USA, Canada, Mexico and all Caribbean Islands'
    },
    worldwideIncluding: {
        id: 'qnb.spt.IpidPage.worldwideIncluding',
        defaultMessage: 'Worldwide plus the USA, Canada, Mexico and all Caribbean Islands'
    },
    europe: {
        id: 'qnb.spt.IpidPage.europe',
        defaultMessage: 'Europe'
    },
    NotApplicable: {
        id: 'qnb.spt.IpidPage.NotApplicable',
        defaultMessage: '*Not applicable for trips in the UK'
    },
});
